import React from 'react';
import GeneralTermsAndConditions from './general-terms-and-conditions';

export default () => <GeneralTermsAndConditions language="fr" />;
